// Packages

// Components

// Logic

// Context

// Services

// Styles
import "./Headline.css";

// Assets

export const Headline = () => {
	return (
		<div className='landing-hero-headline'>
			<div className='landing-hero-headline-moving-words'>
				<div className='landing-hero-headline-moving-word'>Find Stories</div>
				<div className='landing-hero-headline-moving-word'>Write Stories</div>
				<div className='landing-hero-headline-moving-word'>Share Stories</div>
				<div className='landing-hero-headline-moving-word'>Read Stories</div>
				<div className='landing-hero-headline-moving-word'>Store Stories</div>
				<div className='landing-hero-headline-moving-word'>Find Stories</div>
				<div className='landing-hero-headline-moving-word'>Write Stories</div>
			</div>
		</div>
	);
};
